import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
    Checkbox,
    Input,
    Label,
    Adornment,
    LabeledControl,
    Image,
} from '@zillow/constellation';

import ArrowDropdownIcon from 'app/shared/images/arrowDropdown.svg';

import { StyledAdornedInput } from './StyledComponents';

import './style.scss';

export default class MultiSelect extends React.Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        label: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                isChecked: PropTypes.bool.isRequired,
                label: PropTypes.string.isRequired,
            })
        ).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
        this.wrapper = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpen && !this.state.isOpen) {
            window.removeEventListener('touchstart', this.handleDocumentClick);
            window.removeEventListener('mousedown', this.handleDocumentClick);
        } else if (!prevState.isOpen && this.state.isOpen) {
            window.addEventListener('touchstart', this.handleDocumentClick);
            window.addEventListener('mousedown', this.handleDocumentClick);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('touchstart', this.handleDocumentClick);
        window.removeEventListener('mousedown', this.handleDocumentClick);
    }

    handleDocumentClick = (event) => {
        if (this.wrapper.current && !this.wrapper.current.contains(event.target)) {
            this.setState({ isOpen: false });
        }
    };

    renderPanel = () => {
        const { onChange, options } = this.props;
        return (
            <div className="MultiSelect-dropdown">
                {options.map((o, i) => (
                    <div key={i} className="MultiSelect-item">
                        <LabeledControl
                            label={<Label>{o.label}</Label>}
                            control={(
                                <Checkbox checked={o.isChecked} onClick={() => onChange(i, !o.isChecked)} />
                            )}
                        />
                    </div>
                ))}
            </div>
        );
    };

    renderPreviewValue = () => {
        const { options } = this.props;
        const checkedOptions = options.filter(o => o.isChecked).map(o => o.label);
        return checkedOptions.length ? `(${checkedOptions.length}) Selected` : '';
    };

    handleToggle = () => {
        this.setState(state => ({ isOpen: !state.isOpen }));
    };

    render() {
        const { isOpen } = this.state;
        const { label } = this.props;
        return (
            <div className="MultiSelect" ref={this.wrapper}>
                <Label>{label}</Label>
                <StyledAdornedInput
                    input={(
                        <Input
                            value={this.renderPreviewValue()}
                            readOnly={true}
                            onClick={this.handleToggle}
                            data-test="MultiSelect-toggle"
                        />
                    )}
                    rightAdornment={(
                        <Adornment>
                            <div className={cx('MultiSelect-dropdown-arrow',
                                { open: isOpen })}
                            >
                                <Image src={ArrowDropdownIcon} alt="" />
                            </div>
                        </Adornment>
                    )}
                />
                {isOpen && this.renderPanel()}
            </div>
        );
    }
}
